import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Empty({
  Icon,
  title,
  description,
  action,
  className,
}: {
  Icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('text-center py-12 px-6 bg-white rounded-lg border border-ducens-border', className)}>
      {Icon && (
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-ducens-bg mb-3">
          <Icon className="w-5 h-5 text-ducens-muted" />
        </div>
      )}
      <h3 className="font-medium mb-1">{title}</h3>
      {description && <p className="text-sm text-ducens-muted">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
